// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"263":"6349d80d989faaa9","548":"b15183c1ea7f72be"}[chunkId] + ".css";
};